import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {BaseComponent} from "../../BaseComponent";
import {Paths} from "../../../utils/Paths";
import {ChangeDashboardEditModeEvent} from "../../../events/ChangeDashboardEditModeEvent";
import {environment} from "../../../../environments/environment";
import {PlatformLocation} from "@angular/common";
import {EditDashboardEvent} from "../../../events/EditDashboardEvent";
import {CreateNewDashboardEvent} from "../../../events/CreateNewDashboardEvent";
import {DashboardService} from "../../../services/dashboard/dashboard.service";
import {ChartControlsComponent} from "../chart-controls/chart-controls.component";
import {EditModeEvent} from "../../../events/EditModeEvent";

@Component({
  selector: 'app-topbar-buttons',
  templateUrl: './topbar-buttons.component.html',
  styleUrls: ['./topbar-buttons.component.css', '../topbar.component.css']
})
export class TopbarButtonsComponent extends BaseComponent {

  @Output('goToRequest') goToRequest: EventEmitter<string> = new EventEmitter();
  @Input('disabled') public disabled!: boolean;
  env = environment.typeOfEnv;
  languages = this.gmService.localeList;
  public isAlarmedProduct = new Array<string>();
  public dashboardService: DashboardService = inject(DashboardService);
  protected readonly Paths = Paths;
  protected chartControlsComponent = ChartControlsComponent;
  protected readonly ChartControlsComponent = ChartControlsComponent;
  private platformLocation: PlatformLocation = inject(PlatformLocation);


  /**
   * Opens another browser tab with the documentation
   */
  // gotoManual(): void {
  //   this.logger.log(`User opens user-manual`);
  //   // const baseHref = this.platformLocation.getBaseHrefFromDOM();
  //   // const path = window.location.origin + baseHref + 'manual/index.html';
  //   window.open(this.userManualURL, '_blank');
  // }

  changeEdit(editMode: boolean) {
    this.eventBus.emitEvent(new ChangeDashboardEditModeEvent(editMode))
  }

  openDiagnosticPage() {
    this.goToRequest.emit(this.Paths.DIAGNOSTICS)
  }

  openAlarmsPage() {
    this.goToRequest.emit(this.Paths.ALERTS)
  }

  editDashboard() {
    this.eventBus.emitEvent(new EditDashboardEvent());
    this.eventBus.emitEvent(new EditModeEvent(true));
  }

  createNewDashboard() {
    this.eventBus.emitEvent(new CreateNewDashboardEvent());
  }
}
